import React, { useState, useEffect } from 'react';
import { Paper, Box, Grid , Chip, Typography, Button,  CircularProgress } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from "moment";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';
import Modal from 'react-bootstrap/Modal';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const UserShifts = () => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [data , setData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const vacationId = useParams();
    const [selectedData , setSelectedData] = useState([]);
    const navigate = useNavigate();
    const [timerData, setTimerData] = useState('')

    const loadData = (selected , loader = true) => {
        if(loader){
            setLoading(true);
        }
        const body = {
            start_date: selected?.Start_Date,
            end_date: selected?.End_Date,
            vacation_bid_id: selected?.Id
        };
        ApiService.post('/myShiftVacationBid', body)
            .then((data) => {
                setData(data?.MySchedule || []);
                setLoading(false);
            })
            .catch((error) => {
                console.error("error");
            })
            .finally(() => setLoading(false));
    };

    const getMyBids = () => {
        setLoading(true)
        ApiService.get('/getMyBids')
            .then(({ data }) => {
                const bids = data?.data;
                const selectedBids = bids.find((item) => item.id == vacationId?.id);
                setSelectedData(selectedBids);
                getTimer(data?.data?.[0]?.Id)
            if (selectedBids) {
                loadData(selectedBids);
            }
        })
            .catch((e) => {
                console.error("error");
                setLoading(false)
        });
    };

    const getTimer = (id) => {
        setLoading(true)
        ApiService.get(`/getVacationBidTimeRemaining/${id}`)
            .then(({ data }) => {
                // setTimerData(data?.data?.time_remaining?.total_seconds)
                setTimerData(data?.data?.time_remaining?.formatted)
        })
            .catch((e) => {
                console.error("error");
                setLoading(false)
        });
    };

    useEffect(()=>{
        getMyBids()
    }, [])

    const columns = [
        { 
            field: 'Date', 
            headerName: 'Shift Date', 
            minWidth : 220,
            valueGetter: (params) => moment(params.row.Date).format('ddd Do MMMM YYYY'),
        },
        {
            field: 'Shift_Code',
            headerName: 'Shift',
            flex: 1,
            minWidth: 100,
                renderCell: (params) => {
                    return <Chip
                        sx={{
                            height: 'auto',
                            '& .MuiChip-label': {
                                display: 'block',
                                whiteSpace: 'normal',
                            },
                        }}
                        style={{
                            textAlign: 'center',
                            padding: '6px 0px',
                            width: '90%',
                            color: '#2E3238',
                            fontSize:'12px',
                            backgroundColor: 'rgba(52, 152, 219, 0.16)',
                            border: '1px solid rgba(52, 152, 219, 0.2)'
                        }}
                        label={params?.row?.ShiftType || params?.row?.ShiftName}
                    />;
                },
        },
        {
            field: 'GroupName',
            headerName: 'Group',
            flex: 1,
            minWidth: 60,
            maxWidth: 60,
            renderCell: (params) => {
                return <Chip
                    sx={{
                        height: 'auto',
                        '& .MuiChip-label': {
                            display: 'block',
                            whiteSpace: 'normal',
                        },
                    }}
                    style={{
                        textAlign: 'center',
                        padding: '6px 0px',
                        width: '90%',
                        color: '#ffffff',
                        fontSize:'12px',
                        backgroundColor: '#0d6efd'
                    }}
                    label={params?.row?.GroupName.split('Group')}
                />;
            },
        },
        {
            field: 'PositionName',
            headerName: 'Position',
            flex: 1,
            minWidth: 140,
            renderCell: (params) => (
                <Chip
                    sx={{
                        height: 'auto',
                        '& .MuiChip-label': {
                            display: 'block',
                            whiteSpace: 'normal',
                        },
                    }}
                    style={{
                        textAlign: 'center',
                        padding: '6px 0px',
                        width: '100%',
                        color: '#2E3238',
                        fontSize:'12px',
                    }}
                    label={params.value ? params.value : params?.row?.orig_emp?.employee_assignment?.Position_Code}
                />
            ),
        },
        {
            field: 'AssignmentName',
            headerName: 'Assignment',
            flex: 1,
            minWidth: 140,
            renderCell: (params) => (
                <Chip
                    sx={{
                        height: 'auto',
                        '& .MuiChip-label': {
                            display: 'block',
                            whiteSpace: 'normal',
                        },
                    }}
                    style={{
                        textAlign: 'center',
                        padding: '6px 0px',
                        width: '100%',
                        color: '#2E3238',
                        fontSize:'12px',
                        backgroundColor:'#ddd'
                    }}
                    label={params.value ? params.value : params?.row?.orig_emp?.employee_assignment?.Assignment_Code}
                />
            ),
        },
        {
            field: 'PTOStatus',
            headerName: 'Status',
            flex: 1,
            maxWidth: 140,
            renderCell: (params) => (
            <div
                style={{
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    width: '100%',
                }}
            >
                {params.row.PTOStatus &&
                <Chip
                    style={{
                    textAlign: 'center',
                    backgroundColor:
                        params.row.PTOStatus == 'Q' ? 'orange' :
                        params.row.PTOStatus === 'D' ? '#000000' :
                            params.row.PTOStatus === 'O' ? '#ff0000' :
                            params.row.PTOStatus === 'F' ? '#01784F' : '#000000',
                    cursor: 'pointer',
                    color: '#fff'
                    }}
                    label={params.row.PTOStatus === 'Q' ? 'Requested' :
                    params.row.PTOStatus === 'D' ? 'Do not fill' :
                        params.row.PTOStatus === 'O' ? 'Open Position' :
                        params.row.PTOStatus === 'F' ? 'Filled' : params.row.PTOStatus}
                />
                }
            </div>
            ),
        },
        {
            field: 'actions', headerName: 'Actions', flex: 1, minWidth : 140,
            renderCell: (params) => {
                const today = new Date();
                const rowDate = new Date(`${params.row.Date}T00:00:00`);
                const isDisabled = params.row.PTOStatus === 'Q' || params.row.PTOStatus === 'O' || rowDate < new Date(today.toDateString());
                return (
                    <>
                        <ButtonTheme variant="filled" color='primary' className='rounded-2' disabled={isDisabled}
                            onClick={() => {
                                postVacBid(params?.row)
                            }}>
                            Request Vacation Bid
                        </ButtonTheme>
                        {(params.row.PTOStatus === 'Q' || params.row.PTOStatus === 'O') ?
                    	<img
                            src="/images/revert.png"
                            onClick={() => {
                                revertVacBid(params?.row?.vacationBidPickId)
                            }}
                            width={20}
                            height={20}
                            style={{ cursor: 'pointer', marginLeft: '10px' }}
                        />: ""}
                    </>
                );
            }
        },
    ];

    const postVacBid = (rowData) => {
        const body = {
            "vacation_bid_id": vacationId?.id,
            "shift_date": rowData?.Date,
        }
        ApiService.post('/vacationBid/request-pick', body)
            .then((data) => {
                setLoading(false);
                toast.success(`${data?.message}, Remaining Picks : ${data?.remaining_picks}, Max Picks : ${data?.max_picks}, Used Picks : ${data?.used_picks}`);
                loadData(selectedData , false)
            })
            .catch((error) => {
                toast.error(error?.data?.message || error?.data || "error");
            });
    };

    const revertVacBid = (id) => {
        const body = {
            vacation_bid_pick_id: id,
        }
        ApiService.post('/vacationBid/cancel-pick', body)
            .then((data) => {
                setLoading(false);
                toast.success(data?.message);
                loadData(selectedData , false)
            })
            .catch((error) => {
                toast.error(error?.data?.message || error?.data || "error");
            });
    };

    const VacationBidContinue = () => {
        setLoading(true)
        const body = {
            "vacation_bid_id": vacationId?.id,
        }
        ApiService.post('/vacationBid/continue', body)
            .then((data) => {
                setLoading(false)
                toast.success(data?.message);
                navigate(`/firehouse/vacation-bid-user`)
            })
            .catch((error) => {
                toast.error(error?.data?.message || error?.data || "error");
            });
    };


    return (
        <>
            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>
            )
                :
                (
                    <>
                        <Paper className="p-4 font-fam" style={{ marginTop: "1rem", minHeight: '98%' }}>
                            <Box className="my-1" sx={{ flexGrow: 1 }}>
                                <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={12} sm={6} md={1} lg={0.7}>
                                            <Button
                                                className="text-decoration-none px-0"
                                                onClick={() => navigate(`/firehouse/vacation-bid-user`)} 
                                                style={{ color: "#555555" }}
                                            >
                                                <ArrowBackIosIcon fontSize="small" /> Back
                                            </Button>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={3} lg={4}>
                                            <Typography variant="h5">
                                                My Shifts
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4} lg={5.5}>
                                        <Box display="flex" flexWrap="wrap" gap={1}>
                                            <Chip
                                                label={
                                                    "From Date : " + moment(selectedData?.Start_Date).format("MM/DD/YYYY")
                                                }
                                                sx={{
                                                    backgroundColor: "rgba(191, 29, 45, 0.8)",
                                                    color: "#fff",
                                                    cursor: "pointer",
                                                }}
                                            />
                                            <Chip
                                                label={
                                                    "To Date : " + moment(selectedData?.End_Date).format("MM/DD/YYYY")
                                                }
                                                sx={{
                                                    backgroundColor: "rgba(191, 29, 45, 0.8)",
                                                    color: "#fff",
                                                    cursor: "pointer",
                                                }}
                                            />
                                            <Chip
                                            label={
                                                <>
                                                Timer at: {timerData}
                                                {/* Timer at: {Math.floor(timerData / 60)} Minutes {timerData % 60} Seconds */}
                                                </>
                                            }
                                            sx={{
                                                fontSize: '14px',
                                                backgroundColor: 'rgba(191, 29, 45, 0.8)',
                                                color: 'white'
                                            }}
                                            />
                                        </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={1.8} lg={1.8}>
                                            <ButtonTheme
                                                variant="filled"
                                                color="primary"
                                                // onClick={VacationBidContinue}
                                                onClick={() => {
                                                    setShowModal(true)
                                                }}
                                            >
                                                Finish Bidding
                                            </ButtonTheme>
                                        </Grid>

                                    </Grid>
                            </Box>

                            <div>
                                {(data?.length > 0) ?
                                     <>
                                        <div className='mt-3'>
                                            <DataGrid
                                                rows={data}
                                                columns={columns}
                                                rowCount={data.length}
                                                checkboxSelection={false}
                                                hideFooter={data.length > 100 ? false : true}
                                                getRowId={(row) => row.id}
                                            />
                                        </div>
                                    </>
                                :
                                   <Box>
                                        <div className='inner-box d-flex flex-column align-items-center justify-content-center' style={{ height: 530 }}>
                                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                                            <div className='mt-2' style={{ color: '#555555' }}>
                                                <Typography variant="body1" sx={{ color: '#555', fontWeight: 500, mt: 2 }}>
                                                    No shifts available for this user between{" "}
                                                    <strong>{moment(selectedData?.Start_Date).format("MM/DD/YYYY")}</strong> and{" "}
                                                    <strong>{moment(selectedData?.End_Date).format("MM/DD/YYYY")}</strong>
                                                </Typography>
                                            </div>
                                        </div>
                                    </Box>
                                }
                            </div>

                        </Paper >
                    </>
            )}

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                <Modal.Title>Finish Bidding</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure to finish the bidding ?</Modal.Body>
                <Modal.Footer>
                <ButtonTheme variant="filled" onClick={() => setShowModal(false)} color='secondary' className='mx-2'>
                    Close
                </ButtonTheme>
                <ButtonTheme variant="filled" onClick={VacationBidContinue} color='primary'>
                    Save
                </ButtonTheme>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default UserShifts;
